import { render, staticRenderFns } from "./EuFundLogos.vue?vue&type=template&id=0c3b8906&scoped=true&"
import script from "./EuFundLogos.vue?vue&type=script&lang=js&"
export * from "./EuFundLogos.vue?vue&type=script&lang=js&"
import style0 from "./EuFundLogos.vue?vue&type=style&index=0&id=0c3b8906&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c3b8906",
  null
  
)

export default component.exports